import React from "react";

import { MarkCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function mark({ width, onResize }: Column.Options) {
	return base(ColumnId.Mark, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default mark;
